export interface AuthorCreationData {
  firstName: string
  lastName: string
  role: string
  orcId?: string
}

export interface AuthorData {
  firstName: string
  lastName: string
  role: string
  orcId?: string
}

export interface WorkCreationRequest {
  workProductId?: string
  grantId?: string
  title: string
  workProductType: string
  doi: string
  isbn: string
  url: string
  language: string
  workProductAbstract: string
  publisher: string
  containerTitle?: string
  page?: string
  volume?: string
  issue?: string
  publicationDate?: Date
  printedDate?: Date
  authors: AuthorCreationData[]
}

export interface WorkUpdateData {
  title: string
  workProductType: string
  doi: string
  isbn: string
  url: string
  language: string
  workProductAbstract: string
  publisher: string
  containerTitle?: string
  page?: string
  volume?: string
  issue?: string
  publicationDate?: Date
  printedDate?: Date
}

export interface WorkData {
  id: string
  title: string
  workProductType: string
  doi: string
  isbn: string
  url: string
  workProductAbstract: string
  publisher: string
  language: string
  containerTitle: string
  page?: string
  volume?: string
  issue?: string
  publicationDate?: Date
  printedDate?: string
  source?: string
  authors?: AuthorData[]
}

export interface OrganizationWorkData {
  id: string
  organizationId: string
  externalGrantId?: string
  grantId?: string
  workProduct: WorkData
}

export interface WorkListPage {
  totalElements: number
  totalPages: number
  currentPage: number
  content: OrganizationWorkData[]
  first: boolean
  last: boolean
}

export enum SearchType {
  DOI = 'doi',
  ISSN = 'issn',
  ISBN = 'isbn',
}

enum MessageStatus {
  SUCCESS = 'OK',
  FAILURE = 'FAILED',
}

enum MessageKey {
  WORK_ID = 'Work ID',
  MESSAGE = 'Message',
}

export interface WorkSearchRequest {
  searchKey: string
  searchType: SearchType
  page: number
  limit: number
}

export interface WorkSearchMessageResponse {
  status: MessageStatus
  key: MessageKey
  message: string
}

export interface SearchWorksParams {
  page: number
  size: number
  sort: string[]
  filters: Record<string, string>
  title?: string
}

export const defaultWorksPage: WorkListPage = {
  totalElements: 0,
  totalPages: 0,
  currentPage: 0,
  content: [],
  first: false,
  last: false,
}

export interface WorkProductAttachmentData {
  id: string
  workProductId: string
  url: string
  name: string
}
